import { render, staticRenderFns } from "./location-input.vue?vue&type=template&id=639b639e&scoped=true&"
import script from "./location-input.vue?vue&type=script&lang=js&"
export * from "./location-input.vue?vue&type=script&lang=js&"
import style0 from "./location-input.vue?vue&type=style&index=0&id=639b639e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b639e",
  null
  
)

export default component.exports